import * as Rx from 'rxjs/index';
import { COOKIE_NAMES } from './cookieManager.service';

export default class GridScrollHistoryService {
  gridApi;
  $scope;

  constructor(private cookieManager) {
    'ngInject';
  }

  registerScrollHistory(gridApi, gridConfig, $scope) {
    // Save Scroll State
    this.gridApi = gridApi;
    this.$scope = $scope;

    const { core, grid } = gridApi;
    let isGridStateLoaded = false;

    // this handles data changes and resizing of grid and columns
    // we only want this to be triggered when registerDataChangeCallback is called
    core.on.rowsVisibleChanged($scope, () => {
      if (isGridStateLoaded) {
        this.saveGridState();
      }
    });

    // this is called only when new grid data is loaded
    grid.registerDataChangeCallback(() => {
      if (gridConfig.data.length) {
        isGridStateLoaded = true;
        this.onGridContentReady();
        this.loadGridState();
      }
    });
  }

  // we're using this observable to pass it to the scrollHistory directive
  isGridReady: Rx.ReplaySubject<boolean> = new Rx.ReplaySubject();

  get cookieNames() {
    return COOKIE_NAMES;
  }

  get gridStateName() {
    return this.cookieNames.EXECECUTE_LIST_GRID_STATE;
  }

  saveGridState(state = null) {
    if (!this.gridApi || !this.gridApi.saveState) {
      return;
    }

    // calling saveState.save returns the state
    state = state || this.gridApi.saveState.save();
    this.cookieManager.setCookie(this.gridStateName, state);

    return state;
  }

  loadGridState() {
    let state = this.getSavedGridState();

    if (state && this.gridApi.saveState) {
      this.gridApi.saveState.restore(this.$scope, state);
    }

    return state;
  }

  getSavedGridState() {
    return this.cookieManager.getCookie(this.gridStateName);
  }

  // Update the observable
  onGridContentReady() {
    this.isGridReady.next(true);
  }
}
